<app-loader *ngIf="loading" [message]="loadingMessage | concat | translate" @fadeIn></app-loader>
<div class="flex gap-3 justify-end" *ngIf="!showConfirm">
  <button *ngIf="!prevDisabled"
    class="group flex items-center gap-1 hover:bg-primary/5 p-2 rounded-md transition {{prevDisabled ? 'cursor-not-allowed' : ''}}"
    [disabled]="prevDisabled" (click)="goPrev.emit()">
    <span
      class="flex items-center justify-center bg-primary/5 text-primary w-8 aspect-square border border-s border-primary rounded-full">
    <mat-icon class="!w-[15px] back-icon group-hover:translate-x-[-3px] transition">arrow_back_ios</mat-icon>
    </span>
    {{ prevTitle | concat | translate}}
  </button>
  <button *ngIf="!nextDisabled"
    class="group flex items-center gap-1 hover:bg-primary/5 p-2 rounded-md transition {{nextDisabled ? 'cursor-not-allowed' : ''}}"
    [disabled]="nextDisabled" (click)="confirmFirst ? showConfirm = true : goNext.emit()">
    {{ nextTitle | concat | translate}}
    <span
      class="flex items-center justify-center bg-primary/5 text-primary w-8 aspect-square border border-s border-primary rounded-full">
    <mat-icon class="group-hover:translate-x-[3px] transition">arrow_forward_ios</mat-icon>
    </span>
  </button>
</div>

<div style="text-align: center" *ngIf="showConfirm" @fadeIn>
  <div class="">
    <p class="lead">{{ confirmText | concat | translate }}</p>
    <p class="confirm-div">
      <button
        type="button"
        mat-raised-button
        class="yes-button zoom-on-hover"
        @fadeIn
        (click)="goNext.emit(); showConfirm = false"
      >
        <mat-icon>done</mat-icon>
        {{ 'Yes' | concat | translate }}
      </button>
      <button
        mat-raised-button
        class="no-button zoom-on-hover"
        @fadeIn
        (click)="showConfirm = false"
      >
        <mat-icon>clear</mat-icon>
        {{ 'No' | concat | translate }}
      </button>
      &nbsp;
    </p>
  </div>
</div>
